import React, { useLayoutEffect, useState } from "react";

const VideoAbout = ({ homeVideoVertical, homeVideoHorizontal }) => {
  const [aboutVideoSrc, setAboutVideoSrc] = useState(homeVideoHorizontal);

  useLayoutEffect(() => {
    const mq = window.matchMedia("(max-width: 767.98px)");
    const apply = () => {
      setAboutVideoSrc(mq.matches ? homeVideoVertical : homeVideoHorizontal);
    };
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, [homeVideoVertical, homeVideoHorizontal]);

  return (
    <div
      id="about-video"
      className="video-about-section container-fluid position-relative py-4 py-lg-5 px-3 px-md-5"
    >
      <div className="container">
        <div className="row align-items-stretch flex-sm-row-reverse gx-2 gx-md-4 gx-lg-5 gy-4 gy-lg-0 px-md-0">
          {/* Mobile: video first. lg+: title card left (order-lg-1), video right */}
          <div className="col-lg-6 col-12 order-1 order-lg-2 align-self-stretch video-about-video-col d-flex flex-column px-0">
            <div className="video-about-visual flex-grow-1 w-100 position-relative rounded-3 shadow overflow-hidden bg-dark">
              <video
                key={aboutVideoSrc}
                poster="https://thebodymethod.s3.us-west-1.amazonaws.com/tbm-about-video.jpg"
                className="video-about-player position-absolute top-0 start-0 w-100 h-100 rounded-3 object-fit-cover border-0"
                data-object-fit="cover"
                data-autoplay
                playsInline
                controls
              >
                <source src={aboutVideoSrc} type="video/mp4" />
              </video>
            </div>
          </div>
          <div className="col-lg-6 col-12 order-2 order-lg-1 align-self-stretch d-flex flex-column px-0">
            <div className="card video-about-copy-card flex-grow-1 h-100 w-100 border-0 px-3 py-3 pb-4 px-md-5 shadow rounded-3">
              <div className="card-body d-flex flex-column justify-content-center h-100 p-0 p-lg-2 pt-3 pt-lg-2">
                <div className="video-about-title mb-3 mb-lg-4">
                  <span className="d-block h2 francois mb-2">¿Qué es</span>
                  <div className="video-about-title-logo-wrap">
                    <img
                      src="https://thebodymethod.s3.us-west-1.amazonaws.com/tbmcert-logo-negro.png"
                      className="video-about-title-logo img-fluid d-block"
                      alt="TBM Certifications"
                    />
                  </div>
                </div>
                <p className="mb-0 mb-3 mb-lg-4 large">
                  Lleva tu formación a otro nivel con nuestras certificaciones.
                  Conoce a profundidad la metodología de The Body Method y
                  aprende a enseñar Sculpt and Burn, Barre y Block Burn Pilates
                  de forma clara, práctica y efectiva. Es una formación diseñada
                  para fortalecer tu conocimiento, refinar tu práctica y
                  transformar tu pasión por el movimiento en una carrera con
                  propósito.
                </p>
                <p className="mb-0 large">
                  Porque creemos en una práctica con base: elegimos la
                  estructura para construir verdadera libertad, elegimos la
                  ciencia porque el cuerpo merece respeto y elegimos formar
                  mujeres capaces de compartir lo que saben y expandir esa
                  fuerza hacia otras.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoAbout;
